// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-page{max-width:520px;width:100%;margin:0 auto;padding:24px 0}@media only screen and (min-width:992px){.status-page{min-height:500px;padding:56px 0 60px}}.status-page__title{margin-bottom:16px;font-family:var(--1ek1u3d);font-size:26px;font-weight:var(--fn4c5m);line-height:40px;text-transform:var(--1ldwmou)}@media only screen and (min-width:992px){.status-page__title{margin-bottom:32px;font-size:36px;line-height:40px}}", ""]);
// Exports
module.exports = exports;
